import React from 'react';

const blogeContent = [
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'1یک خلاصه خیلی جالب', en:'this is  description' },
        likes:5,
        comments:2
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/man-pic-2.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'2یک خلاصه خیلی جالب', en:'this is  description' },
        likes:15,
        comments:24
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'3یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'4یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'5یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'6یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'7یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'8یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'9یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'10یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'11یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'12یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'13یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'14یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'15یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    },
    {
        bgColor:{ leftBgClass:'bg-red', rightBgClass:'bg-white' },
        title:{ fa:'Imgleft یک عنوان ', en:'this is title' },
        headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
        bgIconClass:'bg-orange',
        description:{ fa:'16یک خلاصه خیلی جالب', en:'this is  description' },
        likes:6,
        comments:4
    }
]


export default blogeContent;